// Drives the PDP holo-card media: front/back toggle for the current copy, and
// swaps to the selected variant's own front/back photos on Condition change.
// Reads a per-variant { front, back, front_zoom, back_zoom } URL map embedded
// server-side (see sections/main-product-holo.liquid) rather than guessing
// from the DOM, so it stays correct even when different Condition variants
// have entirely different photos (different physical copies of the same card).
//
// OVERRIDE, added 2026-08-25: this script only ever knew about the ONE
// product this page was server-rendered for. assets/vault-card-group.js can
// swap the visible photo to a completely different sibling product (a
// different physical card sharing the same grade), and when it does, it has
// no way to add that sibling's variant to OUR server-rendered mediaMap — it
// wasn't in this page's data at all. Before this fix, Front/Back clicks after
// such a swap kept resolving against the ORIGINAL product's own photos,
// silently showing a different physical card's back and calling it correct.
// Now vault-card-group.js hands us the swapped-to copy's real front/back URLs
// via data-override-* attributes on this element; applyImage() checks those
// FIRST and only falls back to the static mediaMap when no override is set.
(function () {
  function initVariantMedia(root) {
    if (root.dataset.mediaInit) return;
    root.dataset.mediaInit = 'true';

    var section = root.closest('[data-section]');
    if (!section) return;
    var sectionId = section.getAttribute('data-section');
    var mediaScript = document.getElementById('VariantMedia-' + sectionId);
    if (!mediaScript) return;

    var mediaMap;
    try {
      mediaMap = JSON.parse(mediaScript.textContent);
    } catch (e) {
      return;
    }

    var stage = section.querySelector('.vault-pdp-media') || section;
    var img = stage.querySelector('.vault-holo-photo img');
    var frontBtn = root.querySelector('[data-side="front"]');
    var backBtn = root.querySelector('[data-side="back"]');
    var currentSide = 'front';

    function setActiveButton(side) {
      currentSide = side;
      if (frontBtn) frontBtn.classList.toggle('active', side === 'front');
      if (backBtn) backBtn.classList.toggle('active', side === 'back');
    }

    function currentEntry(variantId) {
      // A sibling swap (vault-card-group.js) always sets overrideFront to a
      // real URL, so a non-empty overrideFront means "use the override",
      // regardless of what variantId we were asked about.
      if (root.dataset.overrideFront) {
        return {
          front: root.dataset.overrideFront,
          back: root.dataset.overrideBack || null,
          front_zoom: root.dataset.overrideFrontZoom || null,
          back_zoom: root.dataset.overrideBackZoom || null
        };
      }
      return mediaMap[variantId];
    }

    function applyImage(variantId) {
      var entry = currentEntry(variantId);
      if (!entry || !img) return;

      if (backBtn) backBtn.hidden = !entry.back;
      if (currentSide === 'back' && !entry.back) {
        setActiveButton('front');
      }

      var url = currentSide === 'back' && entry.back ? entry.back : entry.front;
      var zoomUrl = currentSide === 'back' && entry.back_zoom ? entry.back_zoom : entry.front_zoom;
      if (url) {
        img.src = url;
        img.srcset = '';
      }
      if (zoomUrl) {
        img.dataset.zoomSrc = zoomUrl;
      }
    }

    if (frontBtn) {
      frontBtn.addEventListener('click', function () {
        setActiveButton('front');
        applyImage(root.dataset.currentVariant);
      });
    }
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        setActiveButton('back');
        applyImage(root.dataset.currentVariant);
      });
    }

    // vault-card-group.js dispatches this right after setting the override
    // attributes, so our INTERNAL currentSide resets to front too — not just
    // the button's visual class (which it also sets directly, for the
    // instant the swap happens, before this listener necessarily runs).
    root.addEventListener('vault:thumbs-override-front', function () {
      setActiveButton('front');
    });

    var selectedVariantScript = section.querySelector('[data-selected-variant]');
    if (selectedVariantScript) {
      var observer = new MutationObserver(function () {
        try {
          var v = JSON.parse(selectedVariantScript.textContent);
          if (v && v.id) {
            root.dataset.currentVariant = String(v.id);
            setActiveButton('front');
            applyImage(root.dataset.currentVariant);
          }
        } catch (e) {
          /* ignore malformed intermediate state */
        }
      });
      observer.observe(selectedVariantScript, { childList: true, characterData: true, subtree: true });
    }

    applyImage(root.dataset.currentVariant);
  }

  function init() {
    document.querySelectorAll('[data-vault-thumbs]').forEach(initVariantMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
